import type { XYChartCustomTooltipProps } from '../types/xy-chart-props.js';

/**
 * @deprecated Use `XYChart.Tooltip` instead. The `CustomTooltip` slot will be removed in a future release.
 */
// TODO [APPDEV-17650] Remove CustomTooltip slot.
// eslint-disable-next-line @typescript-eslint/no-deprecated
export const CustomTooltip = (props: XYChartCustomTooltipProps) => null;

// eslint-disable-next-line @typescript-eslint/no-deprecated
CustomTooltip['displayName'] = 'XYChartChart.CustomTooltip';
